import { render, staticRenderFns } from "./DlgExamesList.vue?vue&type=template&id=1a64fea6"
import script from "./DlgExamesList.vue?vue&type=script&lang=js"
export * from "./DlgExamesList.vue?vue&type=script&lang=js"
import style0 from "./DlgExamesList.vue?vue&type=style&index=0&id=1a64fea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports